export type Volume = {
  number: string;
  title: string;
  flag?: string;
  subtitle?: string;
  body: string;
  result: string;
};

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'The Screening System',
    subtitle: 'The operating system — use it before your next class',
    body: 'The 90-Second Screen master flowchart, the 3 screening moments (full intake, walk-in 3 minutes before class, mid-class "I forgot to mention…") with word-for-word scripts, and the Universal Red Flags list. Read it in 15 minutes, use it this same afternoon.',
    result: "You'll always know your next move. Always.",
  },
  {
    number: '02',
    title: 'Spine & Back',
    flag: 'The one the headline is about',
    body: 'Herniated discs, sciatica, stenosis, osteoporosis, scoliosis, "my back always hurts" — 10 spine conditions, each with the flexion / extension / neutral decision table and reformer spring maps for sensitive spines.',
    result: '"I have a bad back" stops being the scariest sentence of your week.',
  },
  {
    number: '03',
    title: 'Lower Body',
    body: 'Knees, hips, ankles and feet: replacements, meniscus, runner\'s knee, bunions and footwork positioning. Includes the reformer footwork guide by condition — range, foot position, resistance.',
    result: 'Footwork decisions handled in the first five minutes of class.',
  },
  {
    number: '04',
    title: 'Upper Body',
    body: 'Rotator cuff, frozen shoulder, carpal tunnel, whiplash history, and the #1 group-class phrase: "I can\'t put weight on my wrists" — with the complete weight-bearing substitution matrix, mat and reformer.',
    result: 'The most common complaint in group class, answered before she finishes the sentence.',
  },
  {
    number: '05',
    title: 'Special Populations',
    body: 'Pregnancy by trimester, postpartum and diastasis, older adults, hypermobility, post-surgical logic, chronic pain. Plus the language guide for talking about bodies and limitations without alarming — or embarrassing — anyone.',
    result: 'Teach every body that walks into your studio — without holding your breath.',
  },
  {
    number: '06',
    title: 'The Professional Shield',
    subtitle: 'Worth the entire price on its own',
    body: 'Scope of practice in plain language, intake & waiver templates, 2-minute defensive documentation, the incident protocol, and the referral scripts that turn local physios into a source of new clients.',
    result: 'Protect your practice — and become the instructor health professionals refer to.',
  },
];

export const insideEveryVolume: string[] = [
  'The same 6-block protocol for every condition',
  'Word-for-word "What to SAY" scripts',
  'Mat + reformer for every adaptation',
  'Red flags → refer-out criteria',
  'Printable one-page cheat sheets',
];
